import React from 'react';
import ReactDOM from 'react-dom';
import App from './componets/App'
import 'bootstrap/dist/css/bootstrap.min.css';
//import './BootstrapTheme/dist/toolkit-minimal.min.css';


const root = document.getElementById("root");
ReactDOM.render(<App/>,root);  